
import { defineComponent } from "vue";
import { dateFormatDate } from "@/utils/date.utils";
import { TrainingData } from "@/types/trainingData.type";

export default defineComponent({
  props: {
    entities: {
      type: Object as () => TrainingData[],
    },
    containerName: {
      type: String,
    },
  },
  setup() {
    return { dateFormatDate };
  },
  data() {
    return {
      rowPerPage: 10 as number,
      totalRows: 0 as number | undefined,
      currentPage: 1 as number,
      skip: 0,
      data: [] as TrainingData[],
      count: 0,
      origin: "" as string,
    };
  },
  mounted() {
    this.refreshEntities();
  },
  methods: {
    async refreshEntities() {
      if (this.entities) {
        this.totalRows = this.entities.length;
      }

      if (this.entities && this.entities.length > 0 && this.totalRows) {
        this.origin = this.entities[0].origin;

        this.data = [];

        let size = (this.currentPage - 1) * this.rowPerPage;

        const condition = (this.totalRows - (this.currentPage - 1) * this.rowPerPage) / 10;

        let skip;
        if (condition >= 1) {
          skip = size + this.rowPerPage;
        } else {
          skip = condition * 10 + size;
        }

        if (size <= this.entities.length) {
          for (let i = size; i < skip; i++) {
            if (this.entities[i].dateTime) {
              this.data.push(this.entities[i]);
            }
          }
        }
      }
    },

    /**
     * set page
     * @param page
     */
    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshEntities();
    },

    /**
     * change page
     * @param {number} page
     */
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshEntities();
    },
  },

  watch: {
    entities: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      handler(val) {
        // - over property
        this.refreshEntities();
      },
      deep: false,
    },
  },
});
